import { initAmplitude, setUserPropsFromQuery } from '@brighterly/lib-core-functions/analytics'

export { flushBeforeLeave, getDeviceId, trackEvent, whenReady } from '@brighterly/lib-core-functions/analytics'
export type { AmplitudeEventName, AmplitudeEventProps } from '@brighterly/lib-core-functions/analytics'

// User prop that tells the SEO site apart from the WP site — both are served from the same domain.
const SOURCE = 'seo-site'

export interface StartAnalyticsOptions {
  apiKey: string | undefined
  serverUrl: string | undefined
  environment: string | undefined
  brand: string | undefined
  deviceType: 'desktop' | 'mobile'
}

/**
 * Starts Amplitude once per page load (the lib ignores later calls) and sends the whitelisted query params as user
 * props. The SDK's own `Page View` stays on for hard loads — the series the WP site has always sent; every page also
 * sends `Page_view` itself (`useEventsPage`). Resolves the device id, `null` when Amplitude is off.
 */
export const startAnalytics = (options: StartAnalyticsOptions): Promise<string | null> => {
  const sourceDomain = window.location.hostname

  const started = initAmplitude({
    apiKey: options.apiKey,
    serverUrl: options.serverUrl,
    userProps: {
      source: SOURCE,
      user_type: 'guest',
      environment: options.environment || '',
      brand: options.brand,
      device_type: options.deviceType,
      source_domain: sourceDomain,
    },
    eventProps: () => ({
      source_domain: sourceDomain,
      device_type: options.deviceType,
    }),
    debug: import.meta.dev,
  })
  setUserPropsFromQuery()

  return started
}
